function removeNoneableItem(nav) {
  const formatNav = JSON.parse(JSON.stringify(nav))
  removeNoneable(formatNav.catalogueList || [])
  return formatNav
}

function removeNoneable(data = []) {
  const len = data.length
  for (let i = len - 1; i >= 0; i--) {
    const info = data[i]
    let child = info.childrenList

    if (child) {
      if (child.length > 0) {
        removeNoneable(child)
      }
    }
    if (!child || child.length === 0) {
      const pageList = info.pageList
      if (!pageList || pageList.length === 0) {
        const index = data.findIndex((d) => d.catalogueId === info.catalogueId)
        data.splice(index, 1)
      }
    }
  }
}

export { removeNoneableItem }
